"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractExternalReceivableId = void 0;
const error_1 = require("../error");
const base64_1 = require("../utils/base64");
const extractExternalReceivableId = ({ filepath, externalReceivableIdRegEx, decodeBase64, }) => {
    const matches = RegExp(externalReceivableIdRegEx).exec(filepath);
    const externalReceivableId = matches?.[1] ?? null;
    (0, error_1.finleyAssert)(externalReceivableId, `Unable to extract externalReceivableId: ${filepath}`);
    if (decodeBase64) {
        const decodedExternalReceivableId = (0, base64_1.base64Decode)(externalReceivableId);
        (0, error_1.finleyAssert)(typeof decodedExternalReceivableId === 'string', `Unable to base64 decode externalReceivableId: ${externalReceivableId}`);
        return decodedExternalReceivableId;
    }
    return externalReceivableId;
};
exports.extractExternalReceivableId = extractExternalReceivableId;
//# sourceMappingURL=extractExternalReceivableId.js.map